import { TamperSealFormValues } from '@moduleAForm';
import { Seal, UpdateAction, UpdateSeal } from '@types';

import { Mapper } from './Mapper';

export class SealMapper extends Mapper<TamperSealFormValues, Seal, UpdateSeal> {
	public mapToForm(data: Seal): TamperSealFormValues {
		return {
			id: data.id,
			action: UpdateAction.NONE,
			field1: data.serialNumber ?? '',
		};
	}

	public mapFormToPayload(formValues: TamperSealFormValues): UpdateSeal {
		return {
			Seal: {
				id: formValues.id,
				serialNumber: formValues.field1,
			},
			action: formValues.action,
		};
	}

	public mapModelToPayload(data: Seal): UpdateSeal {
		return {
			Seal: data,
			action: UpdateAction.NONE,
		};
	}
}
